import * as ActionType from '../utilities/ActionType';
import * as assessmentService from '../services/AssessmentsService';

/**
 * Action to get assignment
 * 
 * @param { guid:string } guid
 * @returns { object } object
 * 
 */
const getAssessment = (guid) => {
    return (dispatch) => {
        assessmentService.getAssessmentData(guid).then((response) => {
            dispatch({
                "type":ActionType.GET_ASSESSMENT,
                "data":response.data
            });
        }).catch((error) => {
            console.log("while getting assessment list in action:_", error);
        })
    }
}

export {
    getAssessment
}